import { Log } from 'ng2-logger';
import React, { Dispatch } from 'react';
import { connect } from 'react-redux';
import Loading from '../../../components/loading/loading';
import Translator from '../../../core/i18n';
import { IAction, IAppState } from '../../../models/action/core';
import { CourseSubNavigateType, IMainCourseMenuTabProps } from '../../../models/pages/main-menu';
import * as Actions from '../../../store/actions/mainMenu';
import CCourseSubNavigation from './course-sub-navigation';
import ReactGA from 'react-ga4';

const _logger = Log.create('CourseNavigation.tsx');
const T = Translator.create();

class CourseNavigation extends React.Component<IMainCourseMenuTabProps, any> {
    public navCourseSideBar: HTMLUListElement | null = null;
    public item: HTMLAnchorElement | null = null;

    constructor(props: any) {
        super(props);
        this.state = {
            isMenuItemClicked: false,
            panelType: ''
        };
    }

    public componentDidMount = () => {
        this.props.dispatch(Actions.getMainMenuCourseTabData());
    };

    componentDidUpdate() {
        if (!this.state.isMenuItemClicked) {
            const firstItem = this.props.menuPanelItems![0];
            if (firstItem && firstItem.name) {
                this.clickItem(firstItem.count!, firstItem.type!.toString());
            }

            this.setState({ isMenuItemClicked: true });
        }
    }

    public clickItem = (itemCount: number, panelType: string | undefined) => {
        window.courseNavigationSelectedItemCount = itemCount;
        if (panelType) {
            let activeStatus = 0;
            if (panelType === CourseSubNavigateType.allOf.toString()) {
                activeStatus = 2;
            } else if (panelType === CourseSubNavigateType.archived.toString()) {
                activeStatus = 0;
            } else {
                activeStatus = 1;
            }

            const isTeacher =
                panelType === CourseSubNavigateType.teacherCourse.toString() ||
                panelType === CourseSubNavigateType.archivedLessonsTeacher.toString();
            this.setState({ panelType });
            this.props.dispatch(
                Actions.getMainMenuCourseContentData(isTeacher, panelType, activeStatus, 'getMainMenuCourseContentData', 'get')
            );
        }
    };

    public menuItemOnClick = (event: React.MouseEvent<HTMLAnchorElement>) => {

        if (event.currentTarget.dataset.paneltype == "6")
        {
            ReactGA.event({
                category: window.location.host,
                action: 'G_MY_LESSONS',
                label:'G_MY_LESSONS', 
                nonInteraction: true, 
              });
        }
        else if (event.currentTarget.dataset.paneltype == "7")
        {
            ReactGA.event({
                category: window.location.host,
                action: 'G_MY_ARCHIVE_LESSONS',
                label:'G_MY_ARCHIVE_LESSONS', 
                nonInteraction: true, 
              });
        }
        const panelType = event.currentTarget.dataset.paneltype;
        const itemCount = event.currentTarget.dataset.count ? parseInt(event.currentTarget.dataset.count, 10) : 0;

        this.clickItem(itemCount, panelType);
    };

    shouldComponentUpdate(nextProps:any, nextState:any) { 
        if (nextProps !== this.props) { 
          return true; 
        } else { 
          return false; 
        } 
    } 

    public render() {
        return (
            <div id="my-courses" className="top-menu-dropdown dropdown-menu">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-3 col-md-4 pl-0">
                            <div className="side-bar">
                                <ul id="courseSubNavigate" className="nav sidebar-list" ref={e => (this.navCourseSideBar = e)}>
                                    {!(this.props.menuPanelItems && this.props.menuPanelItems.length > 0) ? (
                                        <h5>{T.t('r_select_noRecord')}</h5>
                                    ) : (
                                        this.props.menuPanelItems.map((panelItem, index) => {
                                            return (
                                                <li key={index} className="new-notification">
                                                    <a
                                                        key={'mainMenuPanel_' + index}
                                                        ref={e => (this.item = e)}
                                                        onClick={this.menuItemOnClick}
                                                        data-index={index}
                                                        data-count={panelItem.count}
                                                        data-paneltype={panelItem.type}
                                                        href="javascript:void(0)"
                                                        className={this.state.panelType === panelItem.type!.toString() ? 'active' : ''}
                                                        style={{ display: 'inline-flex', width: '100%' }}
                                                    >
                                                        {T.t(panelItem.name)}
                                                        <span className="badge badge-pill badge-light ml-1" style={{ height: '16px' }}>
                                                            {panelItem.count}
                                                        </span>
                                                    </a>
                                                </li>
                                            );
                                        })
                                    )}
                                </ul>
                            </div>
                        </div>

                        <div className="tab-content col-lg-9 col-md-8">
                            {this.props.courseSubNavigationTabParam ? <CCourseSubNavigation /> : ''}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IMainCourseMenuTabProps): IMainCourseMenuTabProps => {
    if (!state) {
        return ownProps;
    }

    const newProps: IMainCourseMenuTabProps = Object.assign({}, ownProps, {
        menuPanelItems: state.mainMenuRoot.menuPanelItems,
        courseSubNavigationTabParam: state.mainMenuRoot.courseSubNavigationTabParam,
        tabActiveStatus: state.mainMenuRoot.tabActiveStatus,
        courseMenuPanelItemsIsLoaded: state.mainMenuRoot.courseMenuPanelItemsIsLoaded
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.mainMenuRoot.menuPanelItems === prev.mainMenuRoot.menuPanelItems;
    return ret;
};

const CCourseNavigation = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(CourseNavigation);

export default CCourseNavigation;
